import React from "react";
import {
    Navigate,
} from "react-router-dom";

import ListComponent from "../../../../../components/container-full/components/list/page";
import AddComponent from "../../../../../components/extra-container-full-3/components/add/page";
import VideosComponent from "../../../../../components/container-full/components/videos/page";


export const extrasFullThreeRoute = [
    {
        path: 'list',
        element: <ListComponent />,
    },
    {
        path: 'add',
        element: <AddComponent />
    },
    {
        path: 'videos',
        element: <VideosComponent />
    },
    {
        path: 'edit',
        element: <Navigate to="/extras/full-three/add" />
    },
    {
        path: 'edit/:id',
        element: <AddComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/extras/full-three/add" />
    },
];